export default __webpack_public_path__ + "static/media/DAIF_UseCase_Screen2_in-end.4627c81f.jpg";